const dataSetUrls = {
  uk: 'https://mth-calculator.morethanheight.com/uk/',
  us: 'https://mth-calculator.morethanheight.com/us/',
  who: 'https://mth-calculator.morethanheight.com/who/',
  fr: 'https://mth-calculator.morethanheight.com/fr/',
  co: 'https://mth-calculator.morethanheight.com/co/',
  'ca-fr': 'https://mth-calculator.morethanheight.com/ca-fr/',
  ca: 'https://mth-calculator.morethanheight.com/ca/',
  cz: 'https://mth-calculator.morethanheight.com/cz/',
  ar: 'https://mth-calculator.morethanheight.com/ar/',
  de: 'https://mth-calculator.morethanheight.com/de/',
  'ch-de': 'https://mth-calculator.morethanheight.com/ch-de/',
  'who-pt': 'https://mth-calculator.morethanheight.com/who-pt/',
  'who-es': 'https://mth-calculator.morethanheight.com/who-es/',
  in: 'https://mth-calculator.morethanheight.com/in/',
  it: 'https://mth-calculator.morethanheight.com/it/',
};

export default dataSetUrls;
